import { Component } from 'react';
import { withServerSideProps } from '@lib/withServerSideProps';
import { splashPageQuery } from '@queries/pages/splash';
import AMS from '@ui/components/ams';
import {
  DL_SHOPS,
  DL_OFFERS
} from '@lib/constants';
import {
  addItemsToDataLayer,
  dataLayerIdGenerator,
  dataLayerIdGeneratorNewItem
} from '@lib/dataLayerUtils';
import Page from '@ui/components/ams/Pages/Page';
import { mapSplashPageData } from '@lib/page-data/splash.map';

class SplashPage extends Component {
  componentDidMount() {
    const {
      pageData,
    } = this.props;

    const {
      splashPage,
    } = pageData;

    const updatedShopItems = splashPage?.shopData.map((shop) => {
      const dataLayerShopId = dataLayerIdGenerator(DL_SHOPS, shop.slug);
      return dataLayerIdGeneratorNewItem(DL_SHOPS, shop, dataLayerShopId);
    });

    addItemsToDataLayer(updatedShopItems, DL_SHOPS);

    const updatedOfferItems = splashPage?.offerData.map((offer) => {
      const dataLayerOfferId = dataLayerIdGenerator(DL_OFFERS, offer.slug);
      return dataLayerIdGeneratorNewItem(DL_OFFERS, offer, dataLayerOfferId);
    });

    addItemsToDataLayer(updatedOfferItems, DL_OFFERS);
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
      locale,
    } = this.props;

    const {
      splashPage = {},
    } = pageData;

    const {
      pageTitle = '',
      metaDescription,
    } = splashPage;

    return (
      <Page
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
        pageTitle={pageTitle}
        metaDescription={metaDescription}
      >
        <AMS.SplashPageContent
          locale={locale}
          splashPageData={splashPage}
          userData={userSessionData.userData}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: splashPageQuery,
  pageDataMapper: mapSplashPageData,
  getPageQueryVariables: ({ query: { splashSlug } }) => ({
    splashSlug,
  })
});

export default SplashPage;
